import { render } from "./WorkorderEdit.vue?vue&type=template&id=5df3ef08"
import script from "./WorkorderEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkorderEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Workorder/WorkorderEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5df3ef08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5df3ef08', __exports__)) {
    api.reload('5df3ef08', __exports__)
  }
  
  module.hot.accept("./WorkorderEdit.vue?vue&type=template&id=5df3ef08", () => {
    api.rerender('5df3ef08', render)
  })

}


export default __exports__